<template>
    <div class="flex items-center justify-between mb-8">
        <Head :title="project.name" />
        <page-title
            :title="$t('projects.projectDetail')"
            :pages="breadcrumbPages"
        ></page-title>
        <!-- „Neue Wohnung" liegt bewusst nur noch in der Bedienleiste der
             Wohnungs-Sektion (ProjectsApartments.vue, Variante B) — sonst gäbe es
             den Knopf doppelt. -->
    </div>

    <!-- Header -->
    <projects-header
        :project="project"
        :feeCalculation="feeCalculation"
        :editBaseLink="route('advisors.projects.edit.base', { project: project.uuid })"
        :editImageLink="route('advisors.projects.edit.image', { project: project.uuid })"
        :editContactLink="
            route('advisors.projects.edit.contact', { project: project.uuid })
        "
        :editResponsibleLink="
            route('advisors.projects.edit.responsible', { project: project.uuid })
        "
    >
    </projects-header>

    <!-- Infobar -->
    <projects-infobar
        :project="project"
        :apartments="apartments"
        :missedDeadlines="missedDeadlines"
        :deleteProjectRoute="route('advisors.projects.delete', { project: project.uuid })"
        :editProjectStateRoute="
            route('advisors.projects.edit.state', { project: project.uuid })
        "
        manageTopicsRoute="advisors.projects.manageTopics"
        :columnsSettingsLink="
            route('advisors.projects.edit.columns', { project: project.uuid })
        "
        :deletable="deletable"
        :deadlinesExportLink="
            route('advisors.projects.deadlines.export', { project: project.uuid })
        "
        :buyersExportLink="
            route('advisors.projects.buyers.export', { project: project.uuid })
        "
        :budgetExportLink="
            route('advisors.projects.budget.export', { project: project.uuid })
        "
        :bkpModalLink="
            route('advisors.projects.bkp.edit', { project: project.uuid })
        "
        :archiveModalLink="
            route('advisors.projects.archive.edit', { project: project.uuid })
        "
        :distributeDocumentsLink="
            route('advisors.projects.documents.distribute.edit', {
                project: project.uuid,
            })
        "
    >
    </projects-infobar>

    <!-- Apartments -->
    <projects-apartments
        :project="project" :apartments="apartments" :buildings="buildings" :level-names="levelNames"
        :level-name-defaults="levelNameDefaults" :level-names-custom="levelNamesCustom">
    </projects-apartments>
</template>

<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import { Link, Head } from "@inertiajs/inertia-vue3";
import PageTitle from "@/Shared/Components/PageTitle";
import ProjectsHeader from "@/Shared/Components/Projects/ProjectsHeader";
import ProjectsInfobar from "@/Shared/Components/Projects/ProjectsInfobar";
import ProjectsApartments from "@/Shared/Components/Projects/ProjectsApartments";
import JetConfirmationModal from "@/Jetstream/ConfirmationModal.vue";
import JetSecondaryButton from "@/Jetstream/SecondaryButton.vue";
import JetDangerButton from "@/Jetstream/DangerButton.vue";

export default defineComponent({
    // `feeCalculation` neu seit dem 2026-08-20 (Auftrag Luca, Entscheide 12
    // und 15): `{mode}` fuer jedes Agenturmitglied, zusaetzlich
    // `{options, updateLink}` nur fuer den Superadmin.
    // `buildings`/`levelNames`/`levelNameDefaults`/`levelNamesCustom` aus der
    // Gebaeude-Gruppierung (Themen 15-18).
    props: ["project", "apartments", "deletable", "missedDeadlines", "feeCalculation", "buildings", "levelNames", "levelNameDefaults", "levelNamesCustom"],
    layout: MainLayout,
    components: {
        Head,
        JetDangerButton,
        JetSecondaryButton,
        JetConfirmationModal,
        PageTitle,
        ProjectsHeader,
        ProjectsInfobar,
        ProjectsApartments,
        Link,
    },
    data() {
        return {
            apartmentToDelete: null,
            showDelete: false,
            breadcrumbPages: [
                {
                    name: this.$t("projects.projects"),
                    href: this.route("advisors.projects.index"),
                    current: true,
                },
                {
                    name: this.project.name,
                    href: "#",
                    current: false,
                },
            ],
        };
    },
});
</script>

<style scoped></style>
